import React from "react";

import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { StyledRadio } from "../../../../../utils/designComponents/StyledRadio";

const OPTION_INSTRUMENTS = ["option", "future_option"];

const QuantityBasis = ({
  defaultQtyBasis,
  top,
  dispatchTop,
  marketOrder,
  limitOrder,
  candleBreak,
  scalingIn,
  addToWinner,
  underlyingPriceTrail,
  positionPriceTrail,
  preserveProfit,
  lossLimit,
  candleTrail,
  grabCents,
  greenToRedCandles,
  greenToRedPositions,
  ratchetBracket,
  breakPrice,
}) => {
  let [
    mo,
    dispatchMarketOrder,
    marketOrderEnabled,
    setMarketOrderEnabled,
  ] = marketOrder;

  let [
    lo,
    dispatchLimitOrder,
    limitOrderEnabled,
    setLimitOrderEnabled,
  ] = limitOrder;

  let [
    cb,
    dispatchCandleBreak,
    candleBreakEnabled,
    setCandleBreakEnabled,
  ] = candleBreak;

  let [
    si,
    dispatchScalingIn,
    scalingInEnabled,
    setScalingInEnabled,
  ] = scalingIn;

  let [
    atw,
    dispatchAddToWinner,
    addToWinnerEnabled,
    setAddToWinnerEnabled,
  ] = addToWinner;

  return (
    <div>
      <FormControl component="fieldset" variant="outlined">
        <RadioGroup
          row
          aria-label="quantityBasis"
          name="quantityBasis"
          value={top.quantityBasis}
          onChange={(ev) => {
            dispatchTop({ quantityBasis: ev.target.value });
            dispatchScalingIn({ quantityBasisValues: [] });
            dispatchAddToWinner({ quantityBasisValues: [] });
            let isOption = OPTION_INSTRUMENTS.includes(top.instrument);
            let isQty = ev.target.value === "QUANTITY";
            let qtyBasisValue = 0;
            if (defaultQtyBasis !== undefined) {
              if (isOption) {
                if (isQty) {
                  qtyBasisValue = defaultQtyBasis["qtyOption"];
                } else {
                  qtyBasisValue = defaultQtyBasis["dollarOption"];
                }
              } else {
                if (isQty) {
                  qtyBasisValue = defaultQtyBasis["qtyStock"];
                } else {
                  qtyBasisValue = defaultQtyBasis["dollarStock"];
                }
              }
              dispatchMarketOrder({ quantityBasisValue: qtyBasisValue });
              dispatchLimitOrder({ quantityBasisValue: qtyBasisValue });
              dispatchCandleBreak({ quantityBasisValue: qtyBasisValue });
            }
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="baseline"
            spacing={1}
          >
            <Grid item xs={1}>
              <Typography color="textSecondary" style={{ fontSize: 12 }}>
                Quantity Basis:
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                value="DOLLARS"
                control={<StyledRadio />}
                label={
                  <Typography style={{ fontSize: 12 }}>Dollars</Typography>
                }
              />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel
                value="QUANTITY"
                control={<StyledRadio />}
                label={<Typography style={{ fontSize: 12 }}>Qty</Typography>}
              />
              {/*
              <FormControlLabel
                value="PERCENT"
                control={<Radio />}
                label="Percent"
              />
              */}
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default QuantityBasis;
